import { HistoricalEvaluationResponse } from './HistoricalEvaluationResponse';
import { buyerDaToolRequestWizardApi } from './api';

export const historicalEvaluationsApi =
  buyerDaToolRequestWizardApi.injectEndpoints({
    endpoints: (build) => ({
      findSimilarHistoricalEvaluations: build.query<
        HistoricalEvaluationResponse[],
        { evaluationId: number }
      >({
        query: ({ evaluationId }) => ({
          url: `/secured/evaluation/${evaluationId}/find-similar`,
          method: 'GET'
        })
      })
    }),
    overrideExisting: false
  });

export const {
  useFindSimilarHistoricalEvaluationsQuery,
  useLazyFindSimilarHistoricalEvaluationsQuery
} = historicalEvaluationsApi;
